// import React from "react";
// import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
// import { Button } from "@/components/ui/button";
// import { Input } from "@/components/ui/default-input";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableHeader,
//   TableRow,
// } from "@/components/ui/table";
// import { useTRPC } from "@/trpc";
// import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
// import * as Icons from "lucide-react";
// import { useForm, useFormContext } from "react-hook-form";
// import { TPlayerSearch, TShortlistAll } from "@/types/trpc.types";
// import { toast } from "sonner";
// import { TRPCClientError } from "@trpc/client";
// import { v4 as uuidv4 } from 'uuid';
// import { useNavigate } from "react-router-dom";
// import { ROUTES_CONFIG } from "@/config/routes.config";
// import { convertNumberToMarketValue } from "@/lib/utils";
// import { hasRight } from "@/config/rights.config";
// import { useAuth } from "@/hooks/use-auth";
// import {
//   useReactTable,
//   getCoreRowModel,
//   getExpandedRowModel,
//   getGroupedRowModel,
//   getSortedRowModel,
//   flexRender,
//   ColumnDef,
//   ExpandedState,
//   GroupingState,
//   SortingState,
//   Row,
//   CellContext,
// } from "@tanstack/react-table";

// type Player = TPlayerSearch['players'][number]

// interface TableState {
//     page?: number | string;
//     limit?: number | string;
// }

// type ShortlistItem = TShortlistAll['shortlist'][number];

// const normalizeFilterInput = (filters: TableState) => ({
//     ...filters,
//     page: filters.page ? Number(filters.page) : undefined,
//     limit: filters.limit ? Number(filters.limit) : undefined,
// });

// const OverviewTable = () => {
//     const { user } = useAuth()
//     const navigate = useNavigate();
//     const { trpc } = useTRPC();
//     const { getValues, setValue, watch } = useForm<TableState>({
//         defaultValues: {
//             page: 1
//         }
//     })
//     const filterState = watch();

//     const [grouping, setGrouping] = React.useState<GroupingState>(['position']);
//     const [expanded, setExpanded] = React.useState<ExpandedState>(true);
//     const [sorting, setSorting] = React.useState<SortingState>([
//       { id: 'position', desc: false }
//     ]);

//     const query = useQuery({
//       queryKey: ['shortlist'],
//       queryFn: async () => {
//         const input = normalizeFilterInput(getValues());
//         const shortlist = await trpc.shortlist.getAll.query(input);
//         return shortlist;
//       }
//     })

//     const columns = React.useMemo<ColumnDef<ShortlistItem, string | undefined>[]>(
//       () => [
//         ...(hasRight(user?.role?.name, "SHORTLIST.WRITE") ? [{
//           id: 'remove',
//           cell: ({ row }: CellContext<ShortlistItem, string | undefined>) => {
//             if (row.getIsGrouped()) return null;
//             return <RemoveShortlistButton player={row.original.player as Player} />;
//           },
//         } as ColumnDef<ShortlistItem, string | undefined>] : []),
//         {
//           accessorKey: 'position',
//           header: 'Pos.',
//           cell: ({ getValue }: CellContext<ShortlistItem, string | undefined>) => {
//             return <p>{getValue() || "-"}</p>;
//           },
//         },
//         {
//           id: 'name',
//           accessorFn: (row: ShortlistItem) => row.player?.name,
//           header: 'Naam',
//           cell: ({ row, getValue }: CellContext<ShortlistItem, string | undefined>) => {
//             const item = row.original;
//             return (
//               <div
//                 className="flex items-center gap-2 cursor-pointer group/name"
//                 onClick={() => {
//                   if (item.player?.id === undefined) return;
//                   navigate(ROUTES_CONFIG.APP.PLAYER_DETAIL.$buildPath({ params: { player_id: item.player?.id } }));
//                 }}
//               >
//                 <div className="size-8 aspect-square rounded-full bg-foreground/10">
//                   <Avatar>
//                     <AvatarImage
//                       src={item.player?.imageUrl ?? undefined}
//                       alt={item.player?.name ?? undefined}
//                     />
//                     <AvatarFallback>
//                       {item.player?.name?.charAt(0)}
//                     </AvatarFallback>
//                   </Avatar>
//                 </div>
//                 <p className="group-hover/name:underline font-medium">{getValue() || "-"}</p>
//               </div>
//             );
//           },
//         },
//         {
//           id: 'club',
//           accessorFn: (row: ShortlistItem) => typeof row.player?.club === "object" ? row.player?.club?.name : "-",
//           header: 'Club',
//           cell: ({ getValue }: CellContext<ShortlistItem, string | undefined>) => {
//             return <p>{getValue()}</p>;
//           },
//         },
//         {
//           accessorKey: 'information_td',
//           header: 'Informatie TD',
//           cell: ({ getValue }: CellContext<ShortlistItem, string | undefined>) => {
//             return <p>{getValue() || "-"}</p>;
//           },
//         },
//         {
//           accessorKey: 'decision',
//           header: 'Besluit',
//           cell: ({ getValue }: CellContext<ShortlistItem, string | undefined>) => {
//             return <p>{getValue() || "-"}</p>;
//           },
//         },
//         {
//           accessorKey: 'advice',
//           header: 'Advies',
//           cell: ({ getValue }: CellContext<ShortlistItem, string | undefined>) => {
//             return <p>{getValue() || "-"}</p>;
//           },
//         },
//         {
//           accessorKey: 'screening',
//           header: 'Screening',
//           cell: ({ getValue }: CellContext<ShortlistItem, boolean | undefined>) => {
//             return <p>{getValue() ? "Ja" : "Nee"}</p>;
//           },
//         } as ColumnDef<ShortlistItem, string | undefined>,
//         {
//           accessorKey: 'scouting',
//           header: 'Scouting',
//           cell: ({ getValue }: CellContext<ShortlistItem, boolean | undefined>) => {
//             return <p>{getValue() ? "Ja" : "Nee"}</p>;
//           },
//         } as ColumnDef<ShortlistItem, string | undefined>,
//         {
//           accessorKey: 'data',
//           header: 'Data',
//           cell: ({ getValue }: CellContext<ShortlistItem, boolean | undefined>) => {
//             return <p>{getValue() ? "Ja" : "Nee"}</p>;
//           },
//         } as ColumnDef<ShortlistItem, string | undefined>,
//         {
//           accessorKey: 'check',
//           header: 'Check',
//           cell: ({ getValue }: CellContext<ShortlistItem, boolean | undefined>) => {
//             return <p>{getValue() ? "Ja" : "Nee"}</p>;
//           },
//         } as ColumnDef<ShortlistItem, string | undefined>,
//         {
//           accessorKey: 'active',
//           header: 'Actief',
//           cell: ({ getValue }: CellContext<ShortlistItem, boolean | undefined>) => {
//             return <p>{getValue() ? "Ja" : "Nee"}</p>;
//           },
//         } as ColumnDef<ShortlistItem, string | undefined>,
//       ],
//       [user?.role?.name, navigate]
//     );

//     const table = useReactTable<ShortlistItem>({
//       data: (query?.data?.shortlist || []) as ShortlistItem[],
//       columns,
//       state: {
//         grouping,
//         expanded,
//         sorting,
//       },
//       onGroupingChange: setGrouping,
//       onExpandedChange: setExpanded,
//       onSortingChange: setSorting,
//       getCoreRowModel: getCoreRowModel(),
//       getGroupedRowModel: getGroupedRowModel(),
//       getExpandedRowModel: getExpandedRowModel(),
//       getSortedRowModel: getSortedRowModel(),
//       autoResetExpanded: false,
//       getRowId: (row, index) => row.mongo_player_id || `row-${index}`
//     });

//       return (
//       <div className="h-full overflow-auto">
//         <div className="flex flex-col justify-between gap-4 h-full">
//           <div className="bg-foreground/10 rounded-md border p-2 overflow-auto h-full">
//             <Table>
//               <TableHeader>
//                 {table.getHeaderGroups().map((headerGroup) => (
//                   <TableRow key={headerGroup.id}>
//                     {headerGroup.headers.map((header) => (
//                       <TableHead key={header.id}>
//                         {header.isPlaceholder
//                           ? null
//                           : flexRender(
//                               header.column.columnDef.header,
//                               header.getContext()
//                             )}
//                       </TableHead>
//                     ))}
//                   </TableRow>
//                 ))}
//               </TableHeader>
//               <TableBody>
//                 {table.getRowModel().rows.map((row) => (
//                   <TableRow
//                     key={row.id}
//                     className={`hover:bg-foreground/10 group/row ${
//                       row.getIsGrouped() ? 'bg-foreground/5 font-semibold' : ''
//                     }`}
//                   >
//                     {row.getIsGrouped() ? (
//                       <TableCell colSpan={columns.length}>
//                         <div className="flex items-center gap-2 font-semibold">
//                           <Button
//                             variant="ghost"
//                             size="sm"
//                             onClick={row.getToggleExpandedHandler()}
//                           >
//                             {row.getIsExpanded() ? (
//                               <Icons.ChevronDown className="w-4 h-4" />
//                             ) : (
//                               <Icons.ChevronRight className="w-4 h-4" />
//                             )}
//                           </Button>
//                           <span className="uppercase">{String(row.groupingValue ?? '-')}</span>
//                           <span className="text-muted-foreground text-sm">
//                             ({row.subRows.length})
//                           </span>
//                         </div>
//                       </TableCell>
//                     ) : (
//                       row.getVisibleCells().map((cell) => (
//                         <TableCell key={cell.id}>
//                           {flexRender(
//                             cell.column.columnDef.cell,
//                             cell.getContext()
//                           )}
//                         </TableCell>
//                       ))
//                     )}
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </div>
//           <div className="flex items-center justify-between gap-4">
//           <p className="text-sm font-medium text-foreground/50">
//             {query?.data?.total} rijen gevonden
//           </p>
  
//           <div className="flex items-center gap-1">
//             <Button
//               variant="outline"
//               onClick={() => setValue("page", 1)}
//               disabled={parseInt(filterState?.page?.toString() || "0") <= 1}
//             >
//               <Icons.ChevronsLeft className="w-4 h-4" />
//             </Button>
//             <Button
//               variant="outline"
//               onClick={() =>
//                 setValue("page", Math.max(1, Number(filterState.page) - 1))
//               }
//               disabled={parseInt(filterState?.page?.toString() || "0") <= 1}
//             >
//               <Icons.ChevronLeft className="w-4 h-4" />
//             </Button>
//             <Input 
//               value={filterState.page}
//               onChange={(e) => {
//                 setValue('page', e.currentTarget.valueAsNumber);
//               }}
//               onBlur={() => {
//                 query.refetch();
//               }}
//               type="number"
//               min={1}
//               max={query?.data?.pages || 1}
//             />
//             <Button
//               variant="outline"
//               onClick={() =>
//                 setValue(
//                   "page",
//                   Math.min(
//                     Number(query?.data?.pages || 1),
//                     Number(filterState.page) + 1
//                   )
//                 )
//               }
//               disabled={Number(filterState.page) >= Number(query?.data?.pages)}
//             >
//               <Icons.ChevronRight className="w-4 h-4" />
//             </Button>
//             <Button
//               variant="outline"
//               onClick={() => setValue("page", query?.data?.pages || 1)}
//               disabled={Number(filterState.page) >= Number(query?.data?.pages)}
//             >
//               <Icons.ChevronsRight className="w-4 h-4" />
//             </Button>
//           </div>
//           </div>
//         </div>
//       </div>
//     );
// }

// const RemoveShortlistButton = ({player}:{player:Player}) => {
//   const queryClient = useQueryClient();
//   const { trpc } = useTRPC();

//   const { mutate: removeFromShortlist } = useMutation({
//     mutationFn: async (player_id:string) => {
//       await trpc.shortlist.remove.mutate({
//         player_id: player_id
//       })
//     },
//     onMutate: async (player_id) => {
//       await queryClient.cancelQueries({ queryKey: ['shortlist'] })
//       const previous = queryClient.getQueryData(['shortlist'])

//       queryClient.setQueryData(['shortlist'], (old?: TShortlistAll) => {
//         if (!old) return old;
      
//         const updatedShortlist = old.shortlist.filter(s => s.mongo_player_id !== player_id);
      
//         return {
//           ...old,
//           shortlist: updatedShortlist,
//           total: old.total - 1,
//         };
//       });

//       return { previous }
//     },  
//     onSuccess: () => {
//       toast.success("Speler verwijderd uit de shortlist");
//       const previous = queryClient.getQueryData(['shortlist'])
//     },
//     onError: (err, _, ctx) => {
//       queryClient.setQueryData(['shortlist'], ctx?.previous)

//       if(err instanceof Error) {
//         toast.error(err.message);
//       } else if(err instanceof TRPCClientError) {
//         toast.error(err.message);
//       } else {
//         toast.error("Er is een onbekende fout opgetreden.");
//       }
//     }
//   })

//   function remove () {
//     if(!player.id) return;
//     removeFromShortlist(player.id.toString());
//   }

//   return (
//     <div className="  relative flex items-center justify-center">
//       <Button onClick={()=>{remove()}} variant="bright" shape="pill" size="icon" className="group-hover/row:opacity-100 opacity-0 z-10 relative">
//         <Icons.UserMinus className="w-4 h-4"/>
//       </Button>
//       <Icons.CheckIcon className="w-4 h-4 text-bright absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-100 group-hover/row:opacity-0"/>
//     </div>
    
//   )
// }

// export default OverviewTable

import ListTable from "@/components/features/short-longlist/table/list-table";

const OverviewTable = () => {
  return <ListTable listType="shortlist" />;
}

export default OverviewTable;